<template>
    <ViewDemandeInscription/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ViewDemandeInscription from "@/components/DemandeInscription/ViewDemandeInscription.vue";

    export default defineComponent({
      name: "ViewDemandeInscriptionPage",
      components: {
        
        ViewDemandeInscription,
      },
    });
  </script>